import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PayLaterService {
  openPayLater() {
    const link = environment.payLaterUrl;
    window.open(link, '_self');
  }
}
